module.exports = __webpack_public_path__ + "img/phone-32.1803a62b.svg";